export const ELASTIC_CONDITION_MUST = 'must'
export const ELASTIC_CONDITION_SHOULD = 'should'
export const ELASTIC_CONDITION_MUST_NOT = 'mustNot'
export const ELASTIC_CONDITIONS = [
  ELASTIC_CONDITION_MUST,
  ELASTIC_CONDITION_SHOULD,
  ELASTIC_CONDITION_MUST_NOT
]

export const ELASTIC_RULE_CONDITION_EQUAL = 'equal'
export const ELASTIC_RULE_CONDITION_GTE = 'gte'
export const ELASTIC_RULE_CONDITION_GT = 'gt'
export const ELASTIC_RULE_CONDITION_LTE = 'lte'
export const ELASTIC_RULE_CONDITION_LT = 'lt'
export const ELASTIC_RULE_CONDITION_MATCH = 'match'
export const ELASTIC_RULE_CONDITION_MATCH_PHRASE = 'match_phrase'
export const ELASTIC_RULE_CONDITION_FULLTEXT_FUZZY = 'fulltext_fuzzy'
export const ELASTIC_RULE_CONDITION_NESTED = 'nested'
export const ELASTIC_RULE_CONDITIONS = [
  ELASTIC_RULE_CONDITION_EQUAL,
  ELASTIC_RULE_CONDITION_GTE,
  ELASTIC_RULE_CONDITION_GT,
  ELASTIC_RULE_CONDITION_LTE,
  ELASTIC_RULE_CONDITION_LT,
  ELASTIC_RULE_CONDITION_MATCH,
  ELASTIC_RULE_CONDITION_MATCH_PHRASE,
  ELASTIC_RULE_CONDITION_FULLTEXT_FUZZY,
  ELASTIC_RULE_CONDITION_NESTED
]
